<script>
import Accordion from "@/components/_Shared/Accordion";
import cities from "@/utils/states/cities";
import freshDesk from "@/utils/freshDesk";

export default {
  props: {
    rules: {
      type: Boolean,
      required: false,
      default: true
    },
    city: {
      type: Object,
      required: true
    }
  },
  components: {
    Accordion
  },
  data() {
    return {
      phone: null
    };
  },
  methods: {
    openFreshdesk() {
      freshDesk.openProofOfPaymentForm();
    }
  },
  mounted() {
    this.phone = cities.getPhone(this.city.display_name);
  }
};
</script>

<template>
  <section>
    <accordion title="Se você precisar de suporte da Donamaid utilize" :opened="true">
      <ul class="no-dots">
        <!-- <li>
          o nosso chat
          <img src="/static/freshchat_icon.png" class="freshchat-icon" height="15px" /> localizado no canto inferior direito em horário comercial
        </li>-->
        <li>
          o ticket pelo
          <a
            href="https://donamaid.freshdesk.com/support/tickets/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b>freshdesk</b>
          </a>
        </li>
        <li>o e-mail suporte@donamaid.com</li>
        <li>os telefones (53) 3199-1009 / (51) 3191-7385</li>
        <li class="dont-use">não utilize as redes sociais</li>
        <li class="dont-use">não utilize o WhatsApp</li>

        <h4 class="mb-0">Horário de atendimento:</h4>
        <p class="mt-0">
          Segunda à sexta das 7h30 às 21h
          <br />Sábado das 8h às 16h
          <br />Domingo das 10h às 13h e 16h às 19h
        </p>
      </ul>
    </accordion>

    <accordion v-if="rules" title="Regras" :opened="true">
      <ul>
        <li>
          Você pode reagendar ou cancelar um pedido gratuitamente
          <a
            href="https://donamaid.freshdesk.com/support/tickets/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b>comunicando</b>
          </a> com até 48h úteis de antecedência
        </li>
        <li>Você pode reagendar ou cancelar entre 48h e 2h úteis de antecedência perdendo 1h de duração da sua limpeza</li>
        <li>Você não pode reagendar ou cancelar um pedido com menos de 2h úteis de antecedência</li>
        <li>O profissional só pode cancelar 2 limpezas ao mês com aviso de 48h úteis de antecedência</li>
        <li>O profissional só pode cancelar 1 limpeza ao mês entre 48h e 2h úteis de antecedência</li>
      </ul>
    </accordion>

    <accordion title="Produtos de limpeza" :opened="true">
      <accordion title="do usuário cliente">
        <p>Você precisa fornecer utensílios que forem necessários, como:</p>
        <ul>
          <li>Balde</li>
          <li>Vassoura</li>
          <li>Escada</li>
          <li>Outros produtos que não estejam inclusos na lista de produtos ou quantidades extras dos produtos fornecidos pelo profissional</li>
        </ul>
      </accordion>

      <accordion title="do profissional autônomo">
        <p>O profissional deve fornecer:</p>
        <ul>
          <li>(500ml) Desinfetante de uso geral</li>
          <li>(200ml) Limpador multiuso</li>
          <li>(200ml) Detergente</li>
          <li>(200ml) Álcool líquido 70%</li>
          <li>(100ml) Lustra móveis</li>
          <li>(1 litro) Água sanitária</li>
          <li>(1 par) de Luvas de borracha</li>
          <li>(4) Panos de chão</li>
          <li>(6) Flanelas</li>
          <li>(1) Esponja</li>
          <li>(1) Esponja de aço</li>
          <li>(3) Sacos de lixo</li>
          <li>(1) Pincel</li>
        </ul>
        <p>Os produtos de limpeza inclusos não utilizados, permanecerão com o profissional.</p>
      </accordion>
    </accordion>

    <accordion title="Responsabilidades" :opened="true">
      <accordion title="da Donamaid">
        <ul>
          <li>Verificar a veracidade do cadastro dos profissionais autônomos</li>
          <li>Manter as avaliações dos profissionais atualizadas</li>
          <li>Gerir o pagamento das limpezas</li>
          <li>Fornecer suporte para comunicação entre profissional e cliente</li>
        </ul>
      </accordion>

      <accordion title="do profissional autônomo">
        <ul>
          <li>Comparecer às limpezas no horário agendado</li>
          <li>Cumprir toda a carga horária contratada</li>
          <li>Otimizar o tempo de limpeza</li>
          <li>A qualidade da limpeza</li>
          <li>Os produtos de limpeza da lista padrão</li>
          <li>Alinhar com o cliente as atividades a serem realizadas</li>
          <li>Seguir as prioridades de limpeza do cliente</li>
          <li>Pedir ao cliente aos 30 minutos finais da limpeza a revisão do serviço prestado</li>
          <li>Seguir todas as regras do aplicativo Donamaid</li>
        </ul>
      </accordion>

      <accordion title="do usuário cliente">
        <ul>
          <li>
            Pagar o boleto antes do vencimento e enviar o comprovante de pagamento através de
            <b
              class="pointer"
              @click="openFreshdesk"
            >ticket</b> com até 48h úteis antes da limpeza se a compra ocorrer com menos de 4 dias úteis de antecedência.
          </li>
          <li>Prover o acesso do profissional ao local da limpeza no horário agendado com tolerância de atraso do cliente de até 30 minutos</li>
          <li>Ao início da limpeza, alinhar com o profissional todas as atividades a serem realizadas no tempo contratado, estabelecendo as prioridades</li>
          <li>Ser sincero(a) durante a limpeza quando questionado(a) pelo profissional ou ser proativo sobre a qualidade do serviço prestado</li>
          <li>Fazer avaliação sincera e descritiva do profissional autônomo pelo formulário de avaliação recebido por e-mail ao final da limpeza</li>
          <li>Solicitar horas extras de limpeza, caso necessário, pelos canais de atendimento Donamaid</li>
          <li>Notificar pelos canais de atendimento Donamaid quando permitida a saída do profissional antes do término acordado</li>
        </ul>
      </accordion>
    </accordion>
  </section>
</template>

<style scoped>
p {
  margin: 0;
}

.no-dots {
  list-style: none;
  padding-left: 0;
}

.no-dots li {
  background: url("/static/icon_order_status_ok.svg") no-repeat 0 6px;
  background-size: 15px 15px;
  padding-left: 20px;
  line-height: 25px;
}

.no-dots li img {
  transform: translateY(3px);
}

.no-dots li.dont-use {
  background: url("/static/icon-error.svg") no-repeat 0 6px;
  background-size: 15px 15px;
}

section {
  width: 100%;
}

ul {
  padding-left: 17px;
}

@media (min-width: 668px) {
  ul {
    padding-left: 40px;
  }

  .no-dots {
    padding-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/FAQ.vue